import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useChats } from "../../hooks/useChats";
import { getUsedFeaturesFromChats, useFeatures } from "../../hooks/useFeatures";
import Modal from "./Modal";
import api from "../../services/api";

export default function ModalUpgradeRequired({ featureName, close }) {
  const { t } = useTranslation();
  const [isRevealing, setIsRevealing] = useState(false);
  const { openTierRecommendation } = useFeatures();
  const { chats } = useChats();

  const feature = {
    name: t(`upgradeRequired.features.${featureName}.title`, ""),
    description: t(`upgradeRequired.features.${featureName}.description`, ""),
  };

  const usedFeatures = useMemo(() => getUsedFeaturesFromChats(chats), [chats]);

  const upgradePlan = async () => {
    let data = await api.getStripePaymentLink(window.location.href, window.location.href);
    window.location.assign(data.data.url);
  };

  const handleUpgrade = () => {
    if (usedFeatures.length > 0) {
      openTierRecommendation();
    } else {
      upgradePlan();
    }
  };

  return (
    <Modal
      show={true}
      close={close}
      size="small"
      className="upgrade-modal"
      action={
        <>
          <button className="gray" onClick={close}>
            {t("upgradeRequired.maybeLater")}
          </button>
          <button className="blue" onClick={handleUpgrade}>
            {t("upgradeRequired.unlockFeature")}
            <i className="material-icons ml-5">chevron_right</i>
          </button>
        </>
      }
    >
      <div className="upgrade-required-wrapper">
        <div className="upgrade-preview-section">
          <div className={`upgrade-preview-content ${isRevealing ? "revealing" : ""}`}>
            <div className="preview-card">
              <div className="preview-header">
                <div className="preview-icon-wrapper">
                  <i className="material-icons">star</i>
                </div>
                <div className="preview-text">
                  <div className="preview-line preview-line-title"></div>
                  <div className="preview-line preview-line-subtitle"></div>
                </div>
              </div>
              <div className="preview-items">
                <div className="preview-item">
                  <i className="material-icons preview-check">check_circle</i>
                  <div className="preview-line preview-line-item"></div>
                </div>
                <div className="preview-item">
                  <i className="material-icons preview-clock">schedule</i>
                  <div className="preview-line preview-line-item-short"></div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="upgrade-reveal-trigger"
            onMouseEnter={() => setIsRevealing(true)}
            onMouseLeave={() => setIsRevealing(false)}
          >
            <div className="reveal-badge">
              <i className="material-icons">play_arrow</i>
              <span>{t("upgradeRequired.hoverToPeek")}</span>
            </div>
          </div>
        </div>
        <div className="upgrade-content">
          <div className="upgrade-badge">
            <i className="material-icons">auto_awesome</i>
            <span>{t("upgradeRequired.proFeature")}</span>
          </div>
          <h2 className="upgrade-title">{feature.name}</h2>
          <p className="upgrade-description">{feature.description}</p>
        </div>
      </div>
    </Modal>
  );
}
